import { useState } from "react";
import { Download, MessageCircle, Share2 } from "lucide-react";
import { inr, useLoad } from "@/lib/api";
import { openWhatsApp, pdfAction } from "@/lib/pdf";

const NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default function MonthlyShare({ year, report }) {
  const [month, setMonth] = useState(new Date().getFullYear() === year ? String(new Date().getMonth() + 1) : "");
  const { data: clinic } = useLoad("/settings/clinic", null);
  const label = month ? `${NAMES[month - 1]} ${year}` : `${year}`;
  const d = month ? report.months[month - 1] : report.totals;
  const path = `/pdf/monthly?year=${year}${month ? `&month=${month}` : ""}`;
  const summary = () => [`*${clinic?.name || "Clinic"} · Profit report ${label}*`, `Net collections: ${inr(d.net_collection)}`, `Expenses: ${inr(d.expenses)}`, `Lab costs: ${inr(d.lab_costs)}`, `*Profit: ${inr(d.profit)}*`].join("\n");
  return (
    <section className="share-bar" data-testid="monthly-share-bar">
      <select value={month} onChange={(e) => setMonth(e.target.value)} data-testid="monthly-share-period-select">
        <option value="">Whole year {year}</option>
        {NAMES.map((n, i) => <option key={n} value={String(i + 1)}>{n} {year}</option>)}
      </select>
      <button className="secondary" onClick={() => pdfAction("download", "get", path)} data-testid="monthly-pdf-download-button"><Download size={15} /> Download PDF</button>
      <button className="secondary" onClick={() => pdfAction("share", "get", path, null, `Profit report ${label}`)} data-testid="monthly-pdf-share-button"><Share2 size={15} /> Share PDF</button>
      <button className="primary" onClick={() => openWhatsApp(summary())} data-testid="monthly-whatsapp-summary-button"><MessageCircle size={15} /> WhatsApp summary</button>
    </section>
  );
}
